import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import msal from './modules/msal';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DefaultPageLayout } from './modules/pages/layouts/DefaultPageLayout';
import Stores from './modules/stores/Stores';
import { StrictMode } from 'react';
import Theme from './modules/theme/Theme';
import { ReportPage, AdminPage, GlobalLogoutPage, LogoutPage } from './modules/pages';
import "./index.css";
import ReactDOM from "react-dom";
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './modules/applicationInsights';

ReactDOM.render(
	<StrictMode>
		<AppInsightsContext.Provider value={reactPlugin}>
			<Theme>
				<Stores>
					<MsalProvider instance={msal}>
						<BrowserRouter>
							<Routes>
								<Route path="logout" element={<LogoutPage />} />
								<Route element={<DefaultPageLayout/>}>
									<Route path="/admin" element={<AdminPage />} />
									<Route path="/global-logout" element={<GlobalLogoutPage />} />
									<Route path="*" element={<ReportPage />} />
								</Route>
							</Routes>
						</BrowserRouter>
					</MsalProvider>
				</Stores>
			</Theme>
		</AppInsightsContext.Provider>
	</StrictMode>,
	document.getElementById('root')
);
